import { createSlice } from '@reduxjs/toolkit'
import {
  betListBlackjackGame, getBlackJackHighRollerTransactions, getBlackJackTransactions,
  getMyBlackJackTransactions, unfinishedBetBlackjackGame
} from 'pages/BlackjackGame/slice-thunk/blackjack.thunk'
import { BET_RESULT } from 'utils/constants/index'
import { plus, minus } from 'number-precision'

const initialState = {
  loading: false,
  betsLoading: false,
  betList: null,
  unFinishedBet: null,
  blackjackTransactions: null,
  myBlackjackTransactions: null,
  blackjackHighRollerTransactions: null,
  liveStats: {
    totalProfit: 0,
    totalWagered: 0,
    totalWins: 0,
    totalLost: 0
  }
}

const {
  actions: {
    resetUnfinishedBet,
    setUpdateMyBet,
    setLiveStats,
    incrementLiveStatsFromBet
  },
  reducer
} = createSlice({
  name: 'blackjack',
  initialState,
  reducers: {
    setLiveStats: (state, action) => {
      const statistics = action.payload?.statistics
      if (!statistics) return state
      return { ...state, liveStats: { ...statistics } }
    },
    incrementLiveStatsFromBet: (state, action) => {
      const bet = action.payload
      if (!bet?.result) return state

      const betAmount = +bet.betAmount || 0
      const winningAmount = +bet.winningAmount || 0
      const isPush = bet.result === 'push'

      return {
        ...state,
        liveStats: {
          totalProfit: isPush
            ? state.liveStats.totalProfit
            : plus(state.liveStats.totalProfit, minus(winningAmount, betAmount)),
          totalWagered: plus(state.liveStats.totalWagered, betAmount),
          totalWins: plus(state.liveStats.totalWins, bet.result === BET_RESULT.WON ? 1 : 0),
          totalLost: plus(state.liveStats.totalLost, bet.result === BET_RESULT.LOST ? 1 : 0)
        }
      }
    },
    resetUnfinishedBet: (state, action) => ({
      ...state,
      unFinishedBet: null
    }),
    setUpdateMyBet: (state, action) => {
      return ({
        ...state,
        myBlackjackTransactions: action.payload
      })
    }
  },
  extraReducers: builder => {
    builder
      .addCase(betListBlackjackGame.fulfilled, (state, { payload }) => ({
        ...state,
        betList: payload
      }))
      .addCase(unfinishedBetBlackjackGame.fulfilled, (state, { payload }) => ({
        ...state,
        unFinishedBet: payload
      }))
      .addCase(getBlackJackTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getBlackJackTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getBlackJackTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
      .addCase(getMyBlackJackTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getMyBlackJackTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          myBlackjackTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getMyBlackJackTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
      .addCase(getBlackJackHighRollerTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getBlackJackHighRollerTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackHighRollerTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getBlackJackHighRollerTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
  }
})

export { resetUnfinishedBet, setUpdateMyBet, setLiveStats, incrementLiveStatsFromBet }

export default reducer
